import { fetcher } from '@commenda/utils';
import { GetDocumentProcessingJobResponse } from './types';

export async function getDocumentProcessingJob(
  jobId: string
): Promise<GetDocumentProcessingJobResponse | null> {
  try {
    const res = await fetcher(`document-processing-job/${jobId}`, {
      method: 'GET',
    });

    if (!res.ok) {
      console.error('Failed to get document processing job status');
      return null;
    }

    const response = await res.json();
    return response;
  } catch (err) {
    console.error('Error getting document processing job status:', err);
    return null;
  }
}
